import React from "react";
import ReactTooltip from "react-tooltip";
import "./style.scss";
import {useTranslation} from "react-i18next";

const SelectMallStore = ({selectedOption, setSelectedOption, avlOptions}) => {
  const {t} = useTranslation();
  return (
    <div className="mallstore-selection">
      <label className="label">{t("selectmallstore.label")}</label>
      <div>
        {avlOptions.map((s) => (
          <div
            className="mallstore-option"
            onClick={() => {
              setSelectedOption(s.id);
            }}
            key={s.id}
          >
            <input
              type="checkbox"
              className="service-label"
              value={s.id}
              checked={s.id === selectedOption}
              onChange={() => {}}
            ></input>
            <label data-tip data-for={s.text} className="service-label">
              {s.text}
            </label>
            <ReactTooltip id={s.text} place="bottom">
              {s.tooltip}
            </ReactTooltip>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectMallStore;
